define('shared/remote/efid/domain',['shared/page/env'],
function(getEnv){
    var DOMAIN = 'accounts.ef.com';

    function getEFIDDomain() {
        return getEnv()
            .then(function (env) {
                var prefix;
                if (env === 'live') {
                    prefix = '';
                }
                else {
                    prefix = env + '-';
                }

                return prefix + DOMAIN;
            });
    }

    return getEFIDDomain;
});
